import _ from 'lodash'

function combineClassNames(classNames) {
  return _.join(_.map(_.compact(classNames), _.trim), ' ')
}

export default combineClassNames
